import { tablet } from '../../../mediaQueries'

const styles = theme => ({
    root: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'stretch',
        alignSelf: 'flex-start',
        [theme.breakpoints.up(theme.breakpoints.values.xs + 1920)]: {
            justifyContent: 'center',
            marginLeft: 0
        },
        marginLeft: '-90px',
        [theme.breakpoints.down(theme.breakpoints.values.xs + tablet)]: {
            flexDirection: 'column',
            margin: 'auto'
        }
    },
    image: {
        width: '100%',
        boxShadow: '0px 8px 30px rgba(0, 0, 0, 0.2)'
    },
    imgWrap: {
        transition: 'opacity 2s cubic-bezier(.4,.28,0,1.03)',
        opacity: 0,
        zIndex: 10,
        maxWidth: '50%',
        [theme.breakpoints.down(theme.breakpoints.values.xs + tablet)]: {
            maxWidth: '100%',
            marginTop: '20px',
            order: 3
        }
    },
    content: {
        flexBasis: '45%',
        display: 'flex',
        justifyContent: 'center',
        opacity: 0,
        transition: 'opacity 2.5s cubic-bezier(.4,.28,0,1.03)',
        alignItems: 'flex-start',
        flexDirection: 'column',
        paddingRight: '50px',
        position: 'relative',
        marginLeft: '90px',
        [theme.breakpoints.down(theme.breakpoints.values.xs + 1360)]: {
            marginLeft: '30px',
            paddingRight: 0
        },
        [theme.breakpoints.up(theme.breakpoints.values.xs + 1920)]: {
            paddingRight: 0
        },
        [theme.breakpoints.down(theme.breakpoints.values.xs + tablet)]: {
            order: 1,
            fontSize: '2rem',
            flexBasis: 'auto',
            maxWidth: '100vw',
            paddingRight: 0,
            textAlign: 'center',
            marginLeft: 0
        }
    },
    scaleDown: {
        transform: 'scale(0)',
        opacity: 0,
        height: 0
    },
    expanded: {
        position: 'absolute',
        bottom: '-8px',
        [theme.breakpoints.down(theme.breakpoints.values.xs + tablet)]: {
            order: 3,
            position: 'relative',
            bottom: 0
        }
    },
    h1: {
        fontSize: '3rem',
        lineHeight: '67.2px',
        color: '#575452',
        display: 'table',
        fontFamily: 'Playfair Display',
        margin: 0,
        fontWeight: '500',
        width: '100%',
        letterSpacing: '0.02em',
        marginBottom: '30px',
        [theme.breakpoints.down(theme.breakpoints.values.xs + 1200)]: {
            fontSize: '2.5rem',
            lineHeight: '50px'
        },
        [theme.breakpoints.down(theme.breakpoints.values.xs + tablet)]: {
            order: 1,
            fontSize: '2rem',
            lineHeight: '40px'
        }
    },
    h2: {
        fontFamily: 'Aktiv Grotesk',
        fontSize: '1rem',
        margin: 0,
        maxWidth: '63ch',
        color: '#575452',
        fontWeight: 400,
        letterSpacing: '0.01em',
        marginBottom: '2.5rem',
        transition: 'all 0.5s',
        overflow: 'hidden',
        lineHeight: '25.6px',
        [theme.breakpoints.down(theme.breakpoints.values.xs + tablet)]: {
            order: 2,
            margin: '12px 10px 0 10px',
            letterSpacing: '0.02em',
            fontSize: '14px',
            maxWidth: '100%'
        }
    },
    btnExpand: {
        marginTop: '-30px'
    },
    strong: {
        fontWeight: 'inherit'
    },
    button: {
        alignSelf: 'flex-start',
        color: '#0045EA',
        fontFamily: 'Aktiv Grotesk',
        fontWeight: 500,
        paddingLeft: 0,
        '&:hover': {
            backgroundColor: 'white'
        },
        transition: 'all 0.3s',
        textTransform: 'none',
        [theme.breakpoints.down(theme.breakpoints.values.xs + tablet)]: {
            order: 3,
            alignSelf: 'center',
            margin: '0 auto 1rem auto'
        }
    }
})

export default styles